import * as React from 'react';
import * as theme from 'theme.js';

import './AccountContentContainer.pcss';

export function AccountContentContainer(props:{children:React.ReactNode, color?:string, hideSupport?:boolean}) {
  const color = props.color ? props.color : theme.CloudGray;
  return (
    <>
      <div className={"profile-content-container"} style={{backgroundColor:color}}>{props.children}</div>
      {!props.hideSupport && <div className={"profile-help"}><strong>Need Help?</strong> Email <a href={"mailto:strive@well-concepts.com"}>strive@well-concepts.com</a></div> }
    </>
);
}